import Image from 'src/design/components/image/Image';
import Paragraph from 'src/design/styleguide/Paragraph';
import Spacing from 'src/design/styleguide/spacing/Spacing';
import WidgetPanel from 'src/components/dashboard/common/WidgetPanel';
import styled from 'styled-components';

export const NoPendingOrdersIllustration = styled(Image).attrs({
  src: '/static/img/illustration-no-pending-orders.svg',
})`
  max-width: ${(props) => (props.small ? '150px' : '300px')};
`;

export const NoPendingRequestsIllustration = styled(Image).attrs({
  src: '/static/img/illustration-no-pending-requests.png',
})`
  max-width: ${(props) => (props.small ? '150px' : '300px')};
`;

export const NoActiveClientsIllustration = styled(Image).attrs({
  src: '/static/img/illustration-no-active-clients.png',
})`
  max-width: ${(props) => (props.small ? '150px' : '380px')};
`;

const NoOrdersContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const EmptyStateContent = ({ message, illustration, messageTop = 'normal' }) => (
  <NoOrdersContentContainer>
    {illustration}
    <Spacing top={messageTop}>
      <Paragraph>{message}</Paragraph>
    </Spacing>
  </NoOrdersContentContainer>
);

const NoOrdersAtAll = () => (
  <EmptyStateContent
    message="No pending orders at the moment."
    illustration={<NoPendingOrdersIllustration />}
  />
);

export const NoPreOrders = () => (
  <EmptyStateContent
    message="No pending pre orders at the moment."
    illustration={<NoPendingOrdersIllustration small />}
  />
);

export const NoBuyOrders = () => (
  <EmptyStateContent
    message="No pending buy orders at the moment."
    illustration={<NoPendingOrdersIllustration small />}
  />
);

export const NoSellOrders = () => (
  <EmptyStateContent
    message="No pending sell orders at the moment."
    illustration={<NoPendingOrdersIllustration small />}
  />
);

export const NoOrdersPanel = () => (
  <WidgetPanel title="Pending Orders" testRef="no-orders-panel">
    <NoOrdersAtAll />
  </WidgetPanel>
);
